import React from 'react';
import { pdf, Font, Document, Page, Text,Ul, Li, Image,View, StyleSheet } from '@react-pdf/renderer';
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf'; 
import FontLetter from '../../../../assets/Fonts/blfont.ttf'; 
import AutomobyLogo from '../../../../assets/Logo/Automoby.png';
import AigLogo from '../../../../assets/Logo/Aig.png';
import AIG_Logistics_Logo from '../../../../assets/Logo/AIG_Logistics_Logo.png'
import { baseFileURL } from '../../../../Api';  
import PdfIcon from "../../../../assets/Icon/FileInfo";

 
Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});
 

Font.register({
    family: 'FontLetter', 
    src: FontLetter, 
});
 
  
const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '30px',
        paddingTop: '30px',
        fontSize: '10px',
        lineHeight: 1.2,  
    },  
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 
    FontLetter: { 
        fontFamily: 'FontLetter'
    }, 

});

 


const MyDocument = ({ container,cargo, cargoWeight }) => (
    <Document>

        <Page size="A4" style={styles.page}>

            <View style={{  flexDirection: "row",  border: "1px solid #555"}}> 
                <View style={{ width: '50%', borderRight: "1px solid #555", padding: "10px" }}>  
                    <Image src={AIG_Logistics_Logo} style={{ marginTop: '5px', marginLeft: '10px', width: '130px', height: 'auto' }} />
                </View>
                <View style={{ width: '50%', padding: "10px"}}> 
                    <Text>BILL OF LADING No. <Text style={styles.b}>{container.bl_number}</Text> </Text>
                    <Text style={{marginTop: '20px', paddingTop: '20px',   borderTop: '1px dashed #555'}}>BOOKING REF. <Text style={styles.b}>{container.booking_number}</Text></Text>
                </View>
            </View>
 

            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '50%', borderRight: "1px solid #555", paddingBottom: "3px" }}>  
                    <Text style={{ width: '100%' , padding: "3px", backgroundColor: '#ebebeb', borderBottom: "1px solid #555", marginBottom: "3px"  }}>SHIPPER/EXPORTER</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px", fontFamily: 'HelveticaBold', }}>{container.shipper ? container.shipper.name : '- - -'}</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.address : '- - -'}</Text> 
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.address_2 : ''}</Text> 
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.district : ''}</Text> 
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.distinct : ''}</Text> 
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.country : ''}, {container.shipper ? container.shipper.city : ''}</Text> 
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>{container.shipper ? container.shipper.code : ''}</Text> 


                </View>
                <View style={{ width: '50%',   paddingBottom: "3px" }}>  
                    <Text style={{ width: '100%' , padding: "3px", backgroundColor: '#ebebeb', borderBottom: "1px solid #555", marginBottom: "3px"  }}>FORWARDING AGENT l REFERENCES</Text>
                    <Text style={{ width: '100%', fontFamily: 'HelveticaBold', fontSize: '12px', marginBottom: "3px", paddingHorizontal: "3px"}}>AIG LOGISTICS LLC</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>TAX ID: 406447983</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>Phone N: +995 599 16 60 60</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>E-mail: Shipping@aiglogistic.com</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>Address: Agmashenebeli  Avenue 154,  Tbilisi 0102, Georgia</Text>
                </View>
               
            </View>
 

            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '50%', borderRight: "1px solid #555", paddingBottom: "3px" }}>  
                    <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb', borderBottom: "1px solid #555", marginBottom: "3px"  }}>CONSIGNEE</Text>
                    <Text style={{ width: '100%', fontFamily: 'HelveticaBold', paddingHorizontal: "3px"}}>{ cargo.name }</Text>
                    <Text style={{ width: '100%', paddingHorizontal: "3px"}}>ID: { cargo.personal }</Text> 
                   
                </View>
                <View style={{ width: '50%', paddingBottom: "3px" }}>  
                    <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb', borderBottom: "1px solid #555", marginBottom: "3px"  }}>NOTIFY PARTY PIER</Text>
                     <Text style={{ width: '100%', paddingHorizontal: "3px"}}>---</Text>
                </View>
               
            </View>

            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '50%', borderRight: "1px solid #555",   }}>  
                    
                        <View style={{  flexDirection: "row"}}> 
                            <View style={{ width: '50%', borderRight: "1px solid #555", paddingBottom: "3px" }}>  
                                <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb',  borderBottom: "1px solid #555",  }}>OCEAN/VESSEL</Text>
                                <Text style={{ width: '100%', fontFamily: 'HelveticaBold', padding: "3px"}}>{container.ship_name || '- - -'} </Text> 
                            </View>
                            <View style={{ width: '50%', paddingBottom: "3px" }}>  
                                <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb',   borderBottom: "1px solid #555"}}>PORT OF LOADING</Text>
                                <Text style={{ width: '100%', fontFamily: 'HelveticaBold', padding: "3px"}}>{container.sender_city ? container.sender_city.name : '- - -'}</Text> 
                                <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb',   borderTop: "1px solid #555", borderBottom: "1px solid #555" }}>PORT OF DISCHARGE</Text>
                                <Text style={{ width: '100%', fontFamily: 'HelveticaBold', padding: "3px"}}> {container.reciever_city ? container.reciever_city.name : '- - -'}</Text> 
                            </View> 
                        </View>

                   
                </View>
                <View style={{ width: '50%', paddingBottom: "3px" }}>  
                    <Text style={{ width: '100%', padding: "3px", backgroundColor: '#ebebeb', borderBottom: "1px solid #555", marginBottom: "3px"  }}>ONWARD INLAND ROUTING</Text>
                     <Text style={{ width: '100%', padding: "3px"}}>---</Text>
                </View>
               
            </View>




            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '32%', borderRight: "1px solid #555" }}>  
                    <Text style={{ textAlign: 'center', width: '100%' , padding: "3px", backgroundColor: '#ebebeb' }}>CARRIER'S RECEIPT</Text>
                </View>
                <View style={{ width: '68%',    }}>  
                    <Text style={{ textAlign: 'center', width: '100%' , padding: "3px", backgroundColor: '#ebebeb' }}>PARTICULARS FURNISHED BY SHIPPER</Text>
                </View> 
            </View>
 


            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px", backgroundColor: '#ebebeb' }}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}>MARKS</Text>
                    <Text style={{ textAlign: 'center', width: '100%'}}>AND NUMBERS</Text>
                </View>
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px", backgroundColor: '#ebebeb' }}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}>NO OF CONT. OR OTHER PKGS.</Text>
                </View>
                <View style={{ width: '36%', borderRight: "1px solid #555", padding: "3px", backgroundColor: '#ebebeb'}}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}>DESCRIPTION OF GOODS </Text>
                </View> 
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px", backgroundColor: '#ebebeb' }}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}>GROSS WEIGHT KGS</Text>
                </View>
                <View style={{ width: '16%', padding: "3px", backgroundColor: '#ebebeb'}}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}>MEASUREMENT</Text>
                </View> 
            </View>
 

            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0 }}> 
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px",   }}>  
                    <Text style={{ textAlign: 'center', width: '100%', fontSize: '8px' }}>CONTAINER №</Text>
                    <Text style={{ fontFamily: 'HelveticaBold', textAlign: 'center', width: '100%'}}>{container.container_number}</Text>
                    <Text style={{ textAlign: 'center', width: '100%',  fontSize: '8px', marginTop: '15px'}}>SEAL №</Text>
                    <Text style={{ fontFamily: 'HelveticaBold',  textAlign: 'center', width: '100%'}}>{container.seal_number}</Text>
                    <Text style={{ fontFamily: 'HelveticaBold',  textAlign: 'center', width: '100%', height: '175px'}}> </Text>
                </View>
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px"}}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}></Text>
                </View>
                <View style={{ width: '36%', borderRight: "1px solid #555", padding: "3px"}}>  
                    <Text style={{ fontFamily: 'HelveticaBold', textAlign: 'center', width: '100%'}}>{cargo.car_info}</Text>
                    <Text style={{ fontFamily: 'HelveticaBold', textAlign: 'center', width: '100%'}}>{cargo.vin} </Text>
                </View> 
                <View style={{ width: '16%', borderRight: "1px solid #555", padding: "3px" }}>  
                    <Text style={{ fontFamily: 'HelveticaBold', textAlign: 'center', width: '100%'}}>KGS {cargoWeight}</Text>
                </View>
                <View style={{ width: '16%', padding: "3px"}}>  
                    <Text style={{ textAlign: 'center', width: '100%'}}></Text>
                </View> 
            </View>
 

 
            <View style={{  flexDirection: "row",  border: "1px solid #555", borderTop: 0}}> 
                <View style={{ width: '50%', height: '100px', borderRight: "1px solid #555", padding: "10px" }}>  
                    
                </View>
                <View style={{ width: '50%', padding: "10px"}}> 
    
                </View>
            </View>
 
 
        </Page>
 
    </Document>
);

const Consignment = ({ defaultContainer, defaultCargo, cargoWeight }) => {
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument cargo={defaultCargo} cargoWeight={cargoWeight} container={defaultContainer} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'invoice.pdf';
        link.click();
    };

    return (
        <span style={{ cursor: 'pointer', display: 'flex', color:' var(--secondary-text-color)', }} onClick={generatePDF}> <PdfIcon style={{   width: '16px', height: '16px'}} /> </span>
    );
};

export default Consignment;
